import { render, staticRenderFns } from "./PlanoTabela.vue?vue&type=template&id=0855ab92&scoped=true&"
import script from "./PlanoTabela.vue?vue&type=script&lang=js&"
export * from "./PlanoTabela.vue?vue&type=script&lang=js&"
import style0 from "./PlanoTabela.vue?vue&type=style&index=0&id=0855ab92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855ab92",
  null
  
)

export default component.exports